import HttpClient from './utils/HttpClient';
import APIError from '../errors/APIError';

import ListOrderLabelsServiceResponse from '../interfaces/IListOrderLabels';

class OrderLabelsService {
  private httpClient = HttpClient;

  public async listOrderLabels(
    companyId: number,
    startedAt: string,
    endedAt: string,
    customerName: string | null,
    orderId: string | null,
    tagId: string | null,
  ): Promise<ListOrderLabelsServiceResponse> {
    try {
      const response = await this.httpClient.get(
        `/companies/${companyId}/tags?companyId=${companyId}&startedAt=${startedAt}&endedAt=${endedAt}&customerName=${
          customerName || ''
        }&orderId=${orderId || ''}&tagId=${tagId || ''}`,
      );

      return response.data;
    } catch (error) {
      const parsedError = error as any;

      let errorMessage = parsedError?.response?.data?.message;

      if (!errorMessage) {
        errorMessage = 'Erro ao tentar listar as etiquetas';
      }

      throw new APIError(errorMessage);
    }
  }
}

export default new OrderLabelsService();
